(() => {
  if (window.__ballegoAutoplayVideosReady) return;
  window.__ballegoAutoplayVideosReady = true;

  const selector = 'video.bal-autoplay-video';

  const prepareAndPlay = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(() => {
        video.controls = true;
      });
    }
  };

  const startAll = (root = document) => {
    root.querySelectorAll(selector).forEach((video) => {
      if (!video.dataset.ballegoAutoplayBound) {
        video.dataset.ballegoAutoplayBound = 'true';
        video.addEventListener('loadedmetadata', () => prepareAndPlay(video), { once: true });
        video.addEventListener('canplay', () => prepareAndPlay(video), { once: true });
      }
      prepareAndPlay(video);
    });
  };

  const restartVisiblePage = () => {
    if (!document.hidden) startAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => startAll(), { once: true });
  } else {
    startAll();
  }

  window.addEventListener('pageshow', () => startAll());
  document.addEventListener('visibilitychange', restartVisiblePage);
  document.addEventListener('shopify:section:load', (event) => startAll(event.target));

  const resumeAfterGesture = () => startAll();
  document.addEventListener('touchstart', resumeAfterGesture, { once: true, passive: true });
  document.addEventListener('pointerdown', resumeAfterGesture, { once: true, passive: true });
})();
